"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaySession = exports.defaultPlaySettings = void 0;
exports.parsePlaySettings = parsePlaySettings;
exports.defaultPlaySettings = { enabled: false, timeLimit: 5, cooldown: 2 };
function parsePlaySettings(value) {
    const input = value;
    const minutes = (value, fallback) => typeof value === 'number' && Number.isFinite(value) && value >= 0.1 && value <= 240 ? value : fallback;
    return { enabled: input?.enabled === true, timeLimit: minutes(input?.timeLimit, 5), cooldown: minutes(input?.cooldown, 2), ...(input?.cooldownApp === 'puzzle' || input?.cooldownApp === 'matching' || input?.cooldownApp === 'alternate' ? { cooldownApp: input.cooldownApp } : {}) };
}
/** Wall-clock deadlines keep background tabs from extending a play session. */
class PlaySession {
    settings;
    startedAt = null;
    lastObjectAt;
    phase = 'play';
    cooldownUntil = 0;
    cooldownActivity = 'sketchpad';
    nextAlternate = 'sketchpad';
    constructor(settings, now) {
        this.settings = settings;
        this.lastObjectAt = now;
    }
    snapshot() {
        return { settings: this.settings, startedAt: this.startedAt, lastObjectAt: this.lastObjectAt,
            phase: this.phase, cooldownUntil: this.cooldownUntil, cooldownActivity: this.cooldownActivity, nextAlternate: this.nextAlternate };
    }
    restore(value) {
        if (!value || typeof value !== 'object')
            return;
        const state = value;
        const timestamp = (n) => typeof n === 'number' && Number.isFinite(n) && n >= 0;
        const activity = (s) => s === 'sketchpad' || s === 'matching' || s === 'puzzle';
        if (!(state.startedAt === null || timestamp(state.startedAt)) || !timestamp(state.lastObjectAt)
            || !timestamp(state.cooldownUntil) || !['play', 'cooldown', 'ready'].includes(String(state.phase))
            || !activity(state.cooldownActivity) || !activity(state.nextAlternate))
            return;
        this.settings = parsePlaySettings(state.settings);
        this.startedAt = state.startedAt;
        this.lastObjectAt = state.lastObjectAt;
        this.cooldownUntil = state.cooldownUntil;
        this.phase = state.phase;
        this.cooldownActivity = state.cooldownActivity;
        this.nextAlternate = state.nextAlternate;
    }
    get idleDurationMs() { return this.settings.cooldown * 60_000; }
    get screensaverDurationMs() { return Math.max(10, this.settings.timeLimit) * 60_000; }
    screensaverDue(now) { return now - this.lastObjectAt >= this.screensaverDurationMs; }
    objectCreated(now) {
        if (this.phase !== 'play')
            return;
        if (this.startedAt === null || now - this.lastObjectAt >= this.idleDurationMs)
            this.startedAt = now;
        this.lastObjectAt = now;
    }
    tick(now) {
        if (this.phase === 'play' && this.settings.enabled && this.startedAt !== null
            && now - this.lastObjectAt < this.idleDurationMs && now - this.startedAt >= this.settings.timeLimit * 60_000) {
            this.phase = 'cooldown';
            this.cooldownActivity = this.settings.cooldownApp === 'alternate' ? this.nextAlternate
                : this.settings.cooldownApp === 'puzzle' ? 'puzzle' : this.settings.cooldownApp === 'matching' ? 'matching' : 'sketchpad';
            if (this.settings.cooldownApp === 'alternate') {
                this.nextAlternate = this.cooldownActivity === 'sketchpad' ? 'matching' : this.cooldownActivity === 'matching' ? 'puzzle' : 'sketchpad';
            }
            this.cooldownUntil = this.startedAt + (this.settings.timeLimit + this.settings.cooldown) * 60_000;
        }
        if (this.phase === 'cooldown' && now >= this.cooldownUntil)
            this.phase = 'ready';
    }
    idle(now) { return now - this.lastObjectAt >= this.idleDurationMs; }
    returnToPlay(now) {
        this.phase = 'play';
        this.startedAt = null;
        this.lastObjectAt = now;
    }
    configure(settings, now) {
        this.settings = settings;
        this.returnToPlay(now);
    }
}
exports.PlaySession = PlaySession;
//# sourceMappingURL=playSession.js.map